import { render, staticRenderFns } from "./newLayout4.vue?vue&type=template&id=bd3671bc&scoped=true&"
import script from "./newLayout4.vue?vue&type=script&lang=js&"
export * from "./newLayout4.vue?vue&type=script&lang=js&"
import style0 from "./newLayout4.vue?vue&type=style&index=0&id=bd3671bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3671bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VTooltip})
